<template>
    <div class="inner-box">
        <div class="title">공지사항</div>
        <div class="title-s">방문예약 시스템 안내사항을 확인하세요.</div>


    </div>
</template>

<script>
    export default {
        name: "Notice",
        data(){
            return {

            }
        },
        methods: {
            main(){
                this.$router.push({path: `/`});
            }
        },
        created(){

        }
    }
</script>

<style scoped>
    .inner-box{
        height: 100%;
        width:95%;
        left: 0;
        right: 0;
        margin: 0 auto 30px;
    }

    @media (min-width: 1000px) {
        .inner-box{
            width:1000px;
        }
    }

    .title{
        font-size:40px;
        text-align:center;
        margin-top:50px;
        padding:0px 0;
    }

    .title-s{
        font-size:15px;
        color:#666;
        text-align:center;
        padding:0 0 30px 0;
    }

    .inner-box button{
        margin:15px 5px;
        padding:10px;
        border:1px solid #d5d5d5;
        text-align:center;
    }

    .inner-box button:first-child{
        background-color: #b3b3b3;
        color:#fff;
    }

</style>